export interface RegionalCenter {
  name: string;
  id: string;
}

export interface StateData {
  name: string;
  abbreviation: string;
  centers: RegionalCenter[];
}

export const regionalCentersData: Record<string, StateData> = {
  "AK": {
    name: "Alaska",
    abbreviation: "AK",
    centers: [],
  },
  "AL": {
    name: "Alabama",
    abbreviation: "AL",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "American Real Estate Capital Group LLC", id: "RC2200000626" },
      { name: "Baypointe EB5 Regional Center, LLC", id: "ID1435252136" },
      { name: "Carolina Global Regional Center Corporation", id: "RC2300002272" },
      { name: "CIG Southeast Regional Center LLC", id: "RC2200000751" },
      { name: "EB5 Affiliate Network Southeast Regional Center LLC f/k/a Affiliate Network State of Georgia Regional Center LLC (former name EB5 Affiliate Network Southeast Regional Center, LLC)", id: "RC2200001155" },
      { name: "Gulf Coast Regional Investment Center LLC", id: "RC2200000479" },
      { name: "Gulf States Regional Center LLC", id: "RC2200000295" },
      { name: "LD Capital SE Regional Center LLC", id: "RC2400009324" },
      { name: "New Orleans & Gulf Coast Regional Center, LLC", id: "ID1216350684" },
      { name: "Reentry Regional Center South, LLC", id: "RC2200001375" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "EB5 Capital - Southeast Regional Center LLC", id: "RC2200000561" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Sunbelt EB-5 Regional Center, LLC", id: "ID1031910052" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "EC Regional Center LLC", id: "RC2300005461" },
      { name: "Carolina Center for Foreign Investment, LLC aka Carolina Center for Foreign Investment Regional Center", id: "RC2300002603" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
    ],
  },
  "AZ": {
    name: "Arizona",
    abbreviation: "AZ",
    centers: [
      { name: "American Lending Center Southwest LLC", id: "RC2200000169" },
      { name: "America West Regional Center, LLC", id: "RC2300006103" },
      { name: "AZ Southwest Regional Center LLC", id: "RC2400009360" },
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "EB5AN AZ and Southern Regional Center LLC", id: "RC2300001758" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "EB5AN Southwest Regional Center LLC", id: "RC2200000238" },
      { name: "Green Card Fund LLC", id: "RC2200000141" },
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "LCP Southwest Regional Center LLC", id: "RC2400006580" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "Zephyrus Regional Center LLC", id: "ID1636255049" },
      { name: "First America Southwest, LLC", id: "RC2300002464" },
      { name: "3G West Coast Regional Center, LLC (former name Halic Capital, LLC)", id: "RC2200000231" },
      { name: "Monterey Northern California Regional Center, LLC", id: "RC2300002531" },
      { name: "Universal Regional Center", id: "RC2300002408" },
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Civitas Las Vegas Regional Center LLC", id: "RC2300001804" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "Great American Southwest Regional Center LLC", id: "RC2400009672" },
      { name: "EB5 Group Southwestern States Regional Center LLC", id: "RC2400009665" },
      { name: "ADF Mountain Regional Center LLC", id: "RC2400012337" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
      { name: "Akal Development Inc.", id: "RC2500015991" },
    ],
  },
  "AR": {
    name: "Arkansas",
    abbreviation: "AR",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "EB5 Capital – Texas Regional Center, LLC", id: "RC2300004915" },
      { name: "Civitas Central Regional Center, LLC", id: "RC2300002995" },
      { name: "Pine State Regional Center, LLC", id: "RC2200000036" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "Smith Texarkana Regional Center, LLC", id: "RC2300003396" },
      { name: "Mid America Fund LLC", id: "RC2300004564" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "Dhanani EB-5 International, LLC", id: "RC2400008818" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
      { name: "Vanguard Investment and Immigration WSC, LLC", id: "RC2500014390" },
    ],
  },
  "CA": {
    name: "California",
    abbreviation: "CA",
    centers: [
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "First America Southwest, LLC", id: "RC2300002464" },
      { name: "168 America Regional Center, LLC", id: "ID1235250868" },
      { name: "Aboard America Regional Center, LLC", id: "RC2300002708" },
      { name: "ABC Global RC, LLC", id: "RC2200000482" },
      { name: "Admiralty California Regional Center LLC", id: "ID1033650026" },
      { name: "Admiralty Sierra Regional Center, LLC", id: "RC2300005725" },
      { name: "Advantage America California Regional Center, LLC", id: "RC2300005772" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "ALC West LLC", id: "RC2200000407" },
      { name: "Alka Empire Regional Center LLC", id: "RC2300004748" },
      { name: "American Advancement Capital Co.", id: "ID1320451180" },
      { name: "American Alliance Regional Center", id: "ID1109050190" },
      { name: "America FX Regional Center, LLC", id: "ID1506352614" },
      { name: "America FX Regional Center, LLC", id: "RC2300003954" },
      { name: "American Dreams RC, LLC", id: "RC2300005214" },
      { name: "American Everglow Regional Center, LLC", id: "ID1332651296" },
      { name: "American Gateway Regional Centers LLC", id: "RC2300002248" },
      { name: "American Greenland Regional Center", id: "RC2300002046" },
      { name: "American Lending Center California LLC", id: "RC2200000089" },
      { name: "American National Regional Center d.b.a. EB5 Financial Regional Center", id: "ID1635854973" },
      { name: "American National Regional Center Southern California", id: "RC2300002360" },
      { name: "American Redevelopment Solutions LLC", id: "ID1031910091" },
      { name: "American Vantage Regional Center", id: "RC2300002054" },
      { name: "Anchor Solutions Regional Center LLC", id: "RC2300003007" },
      { name: "Awesome American Regional Center LLC", id: "RC2300001570" },
      { name: "BC West Coast Regional Center, LLC", id: "RC2300002175" },
      { name: "Beresford Regional Center", id: "ID1527553326" },
      { name: "Behring Regional Center LLC", id: "RC2200000116" },
      { name: "Broadway Regional Center, LLC", id: "ID1527353225" },
      { name: "CA EB-5 Express LLC", id: "RC2300002665" },
      { name: "OneWorld Regional Center LLC", id: "RC2200000470" },
      { name: "California Consortium for Agricultural Export (CCAE)", id: "ID1031910155" },
      { name: "California EB-5 Regional Center, LLC", id: "RC2200000165" },
      { name: "California Energy Investment Center, LLC", id: "RC2300002204" },
      { name: "Southern California Regional Center, LLC", id: "RC2300003018" },
      { name: "California Green Regional Center LLC", id: "RC2300002450" },
      { name: "Kao & Lo LLC", id: "ID1114050205" },
      { name: "California Investment Regional Center, LLC", id: "ID1312651131" },
      { name: "California One Investment Center, LLC", id: "ID1326051211" },
      { name: "California Real Estate Regional Center", id: "ID1034250070" },
      { name: "California State Regional Center", id: "RC2300002610" },
      { name: "California Sunshine Regional Center, LLC", id: "RC2300001998" },
      { name: "California Wineries & Vineyards, LLC Regional Center (CWVRC)", id: "RC2300001671" },
      { name: "CanAm California Regional Center LLC (former name CanAm Los Angeles Conty Regional Center and Los Angeles Film Regional Center)", id: "RC2200000080" },
      { name: "Century American Regional Center", id: "ID1031910058" },
      { name: "Civitas NorCal Regional Center", id: "RC2300001822" },
      { name: "Civitas Pacific Regional Center LLC", id: "RC2300003456" },
      { name: "Civitas SoCal Regional Center, LLC", id: "RC2300001846" },
      { name: "CMB Export LLC", id: "RC2200000040" },
      { name: "Continental Regional Center LLC (former name USA Continental Regional Center, LLC)", id: "RC2300001442" },
      { name: "Delvelyn Regional Center, LLC", id: "RC2200001198" },
      { name: "Discovery California Regional Center LLC", id: "RC2200000461" },
      { name: "Dos Lagos Regional Center", id: "RC2300002387" },
      { name: "JDC Regional Center LLC (former name DoubleDoor EB5 Management LLC)", id: "RC2300005776" },
      { name: "Eagle EB-5 Regional Center", id: "ID1527353209" },
      { name: "EB5AN CA and Central Regional Center LLC", id: "RC2300001980" },
      { name: "3G West Coast Regional Center, LLC (former name Halic Capital, LLC)", id: "RC2200000231" },
      { name: "EB5 Capital - California Regional Center LLC", id: "RC2200000007" },
      { name: "EB-5 Impact Capital Regional Center, LLC", id: "ID1410551734" },
      { name: "EB5 United West Regional Center, LLC", id: "RC2300003337" },
      { name: "Emerald Pond Regional Center LLC", id: "RC2300002966" },
      { name: "Encore California RC LLC", id: "RC2300002333" },
      { name: "KT Holdings Inc", id: "RC2300003149" },
      { name: "Gateway Secured, Inc. (aka Gateway Secured Regional Center)", id: "RC2300003081" },
      { name: "Genesis Global Regional Center, LLC", id: "RC2300003472" },
      { name: "Gladstone Regional Center, LLC", id: "ID1635855005" },
      { name: "Global Pacific Regional Center (former name American Sun Regional Center)", id: "ID1129050334" },
      { name: "Global Premier America Regional Center LLC", id: "ID1031910066" },
      { name: "Golden Bear Regional Center", id: "RC2300002069" },
      { name: "Golden State Renaissance Ventures LLC DBA Golden Gate Global", id: "ID1031910162" },
      { name: "Golden Opportunity Regional Center LLC", id: "RC2300002325" },
      { name: "Grand Commonwealth Regional Center LLC", id: "RC2300002095" },
      { name: "Green Energy Regional Center LLC", id: "RC2300001566" },
      { name: "New Course West Regional Center LLC", id: "RC2200001128" },
      { name: "Group I Regional Center, LLC", id: "ID1329651243" },
      { name: "GSC Western Regional Center, LLC", id: "RC2300005279" },
      { name: "Happy Family USA Regional Center", id: "ID1527153031" },
      { name: "Hollywood Regional Center", id: "ID1031910034" },
      { name: "Home Paradise Investment Center LLC", id: "RC2400006436" },
      { name: "Inland Empire Renewable Energy Regional Center LLC", id: "RC2300002287" },
      { name: "Invest LA Regional Center, LLC", id: "ID1031910016" },
      { name: "JKML Regional Center LLC", id: "RC2400008845" },
      { name: "L.A. Life Regional Center", id: "RC2400009552" },
      { name: "LA Growth Fund LLC", id: "RC2200001139" },
      { name: "Live in America – California Regional Center LLC", id: "RC2400006717" },
      { name: "Local Equity Regional Center LLC", id: "RC2300004157" },
      { name: "Los Angeles International Regional Center, LLC", id: "RC2300003497" },
      { name: "American Dream Fund LLC (dba Los Angeles Regional Center)", id: "ID1031910112" },
      { name: "M&D Regional Center, LLC", id: "RC2300002471" },
      { name: "Mebo Property Development Regional Center, LLC (former name Mebo Property Development LLC )", id: "ID1116850232" },
      { name: "Mirae Creative Development, LLC", id: "RC2300004402" },
      { name: "Monterey Northern California Regional Center, LLC", id: "RC2300002531" },
      { name: "Monterey Southern California Regional Center, LLC", id: "RC2200000902" },
      { name: "National EB-5 Wealth Center of California LLC", id: "RC2400008972" },
      { name: "NewGen CA Regional Center, LLC", id: "RC2200000791" },
      { name: "New World Real Estate & Development LLC (former name New World Regional Center)", id: "RC2300003144" },
      { name: "North Valley Regional Center", id: "RC2300003125" },
      { name: "Norton Group Regional Center, LLC", id: "RC2300003491" },
      { name: "OIS-NCA LLC", id: "RC2300002548" },
      { name: "Pacific Coast USA Regional Center LLC", id: "RC2300002990" },
      { name: "Pacific Dynasty Regional Center", id: "RC2300002402" },
      { name: "Pine State Regional Center Northwest LLC", id: "RC2400009046" },
      { name: "Proficiency Regional Center LLC", id: "RC2400008543" },
      { name: "Rancon Regional Center, LLC", id: "RC2400006429" },
      { name: "Terra Ventures Regional Center LLC", id: "RC2300005321" },
      { name: "Regional Center Properties, Inc.", id: "ID1031910143" },
      { name: "SDEB5RC, LLC d/b/a San Diego EB-5 Regional Center", id: "RC2400009192" },
      { name: "San Diego Regional Center, LLC", id: "RC2300002754" },
      { name: "San Francisco EB-5 Regional Center, LLC", id: "ID1108750186" },
      { name: "SPI EB5 Pacific RC, LLC", id: "RC2200000409" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "SoCal Investment Regional Center LLC", id: "RC2300002469" },
      { name: "Southern California Health and Hospitality Regional Center LLC", id: "RC2400009442" },
      { name: "Southern California Commercial Regional Center LLC (former name US Commercial Regional Center)", id: "ID1031910201" },
      { name: "SPI EB5 CA, LLC", id: "RC2300002907" },
      { name: "Toma Regional Center LLC", id: "RC2200000476" },
      { name: "Summit Regional Center LLC", id: "RC2300001560" },
      { name: "Sun Island LLC", id: "RC2300002066" },
      { name: "U.S. Immigration Fund – CA, LLC", id: "ID1705355468" },
      { name: "United Venture Regional Center, LLC", id: "ID1034150055" },
      { name: "Universal Regional Center", id: "RC2300002408" },
      { name: "Vegas Regional Center, LLC", id: "ID1625654407" },
      { name: "Waylee Investment, LLC", id: "ID1205350598" },
      { name: "WC Regional Center LLC", id: "RC2300005222" },
      { name: "West Coast EB5 Regional Center, LLC", id: "RC2200001186" },
      { name: "West Maingate Regional Center, LLC (former name US Maingate Regional Center, LLC)", id: "RC2300003090" },
      { name: "Western Capital Regional Center", id: "ID1336551549" },
      { name: "Western Fortune Regional Center", id: "RC2300002378" },
      { name: "YK America Regional Center LLC", id: "RC2200000824" },
      { name: "Zephyrus Regional Center LLC", id: "ID1636255049" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "ARCG Nevada Regional Center LLC (former name Geothermal Regional Center LLC)", id: "RC2300002370" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "AJC Regional Center LLC", id: "RC2400009642" },
      { name: "EB5AN Far West Regional Center LLC", id: "RC2200000215" },
      { name: "Businvest, LLC", id: "RC2400009319" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "American Citizen Regional Center Southern California, LLC", id: "RC2300002296" },
      { name: "EB5 Group Western States Regional Center LLC", id: "RC2400009668" },
      { name: "American Innovation West Coast Regional Center LLC", id: "RC2400009772" },
      { name: "Regency Global Regional Center, LLC", id: "RC2400009904" },
      { name: "Pan Enterprise Regional Center", id: "RC2400011684" },
      { name: "Monroe Regional Center, LLC", id: "RC2500014484" },
      { name: "Akal Development Inc.", id: "RC2500015991" },
    ],
  },
  "CO": {
    name: "Colorado",
    abbreviation: "CO",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "Monterey Northern California Regional Center, LLC", id: "RC2300002531" },
      { name: "ALC Rocky Mountain LLC", id: "RC2200000299" },
      { name: "American Lending Center Colorado LLC", id: "RC2300002761" },
      { name: "Asian Physicians & Professional EB5 Regional Center LLC", id: "RC2300005502" },
      { name: "Biz51 Group Regional Center LLC", id: "RC2300003696" },
      { name: "Civitas Denver Regional Center, LLC", id: "RC2300001828" },
      { name: "CMB Colorado Regional Center, LLC", id: "RC2200000326" },
      { name: "Colorado Rocky Mountain High Regional Center, LLC", id: "RC2300002377" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "InvestAmerica EB5 LLC", id: "RC2200001283" },
      { name: "KCI Colorado Regional Center LLC", id: "RC2300001650" },
      { name: "LCP Colorado Regional Center LLC", id: "RC2300003471" },
      { name: "Mountain West Regional Center, LLC", id: "RC2300003482" },
      { name: "Rosewood Regional Center LLC", id: "RC2400009182" },
      { name: "Global Crossing, LLC (former name Smith Mountain Regional Center, LLC)", id: "RC2300003985" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Green Pathway Regional Center, LLC", id: "RC2300004593" },
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "EB5 Southwest RC LLC", id: "RC2400012362" },
      { name: "Texas Lending Alliance, LLC", id: "RC2500014075" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "American Greenfield Regional Center LLC", id: "RC2400011778" },
      { name: "Global Gateway LLC", id: "RC2400011753" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
    ],
  },
  "MP": {
    name: "Commonwealth of Northern Mariana Islands",
    abbreviation: "MP",
    centers: [
      { name: "American Northern Marianas Regional Center LLC", id: "RC2200001024" },
      { name: "Invest CNMI, LLC", id: "ID1435352159" },
    ],
  },
  "CT": {
    name: "Connecticut",
    abbreviation: "CT",
    centers: [
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "Allstates QSR Regional Center, LLC", id: "RC2400008961" },
      { name: "American EB-5 Properties Regional Center, LLC", id: "ID1435652190" },
      { name: "AscendAmerica LLC", id: "RC2200000422" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "A 1 Regional Center", id: "RC2200001023" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 Capital - New York Regional Center LLC", id: "RC2300002093" },
      { name: "BTM Greater NY Regional Center, Inc.", id: "RC2200001378" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Harmonia Regional Center New York", id: "ID1516152743" },
      { name: "LCR Overseas Regional Center LLC", id: "RC2300002338" },
      { name: "EB5 Northeast RC, LLC (former name Liberty Harbor Regional Center, LLC)", id: "RC2300002355" },
      { name: "Lightstone New York Regional Center LLC", id: "RC2300001784" },
      { name: "Live in America - Connecticut Regional Center", id: "RC2300001461" },
      { name: "LUC Capital, LLC", id: "RC2300001605" },
      { name: "Manhattan Metropolitan Regional Center", id: "ID1501652543" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Midtown NYC Regional Center, LLC", id: "RC2300003738" },
      { name: "Mugo Regional Center LLC", id: "ID1610954307" },
      { name: "New Empire EB-5 Regional Center, LLC", id: "RC2400009359" },
      { name: "New England Family Regional Center LLC (former name New England Federal Regional Center)", id: "ID1205450600" },
      { name: "New York City Transportation Regional Center LLC", id: "RC2300004603" },
      { name: "New York Connecticut Regional Center, LLC", id: "RC2300001575" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "NY Entrepreneurs Fund, LLC", id: "RC2300003467" },
      { name: "NY Hudson Capital Partners LLC", id: "RC2400008901" },
      { name: "NYC Liberty Green Regional Center, LLC", id: "ID1635854999" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "Northern Regional Center LLC", id: "RC2300002271" },
      { name: "United Land RC LLC", id: "RC2300001945" },
      { name: "USCFID New York LLC", id: "RC2200001395" },
      { name: "USANY Regional Center LLC", id: "RC2300005057" },
      { name: "TOEC Regional Center LLC", id: "ID1504452595" },
      { name: "East Coast Regional Center, LLC", id: "RC2300004768" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Civitas New York Regional Center, LLC", id: "RC2300001834" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "Metropolis Regional Center, LLC", id: "RC2400009628" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "New England EB5 Regional Center LLC", id: "RC2300005197" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "DE": {
    name: "Delaware",
    abbreviation: "DE",
    centers: [
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "Delaware Valley Regional Center, LLC", id: "RC2300001599" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "EB5 Capital - DC Regional Center", id: "RC2200000001" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
    ],
  },
  "DC": {
    name: "District of Columbia",
    abbreviation: "DC",
    centers: [
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Tran EB5 Regional Center LLC", id: "RC2300005894" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "Allstates QSR Regional Center, LLC", id: "RC2400008961" },
      { name: "American Heritage Regional Center, LLC", id: "ID1525452912" },
      { name: "CanAm Greater Washington Regional Center LLC (former name American Lending Center Virginia, LLC)", id: "RC2300001489" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "Chesapeake Regional Center, LLC", id: "ID1306051099" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "EB5 Capital - DC Regional Center", id: "RC2200000001" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Live in America - Washington D.C./Baltimore Regional Center LLC", id: "RC2300001446" },
      { name: "Maryland Center for Foreign Investment, LLC", id: "ID1031910002" },
      { name: "Maryland Global Regional Center, LLC", id: "ID1335851436" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Milou Chesapeake Regional Center LLC (former name Oriental Dolphin EB-5 Regional Center)", id: "RC2300002524" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
    ],
  },
  "FL": {
    name: "Florida",
    abbreviation: "FL",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "American EB5 Regional Center", id: "ID1525452903" },
      { name: "American Lending Center Florida LLC", id: "RC2200000134" },
      { name: "EB5 for Florida Regional Center, LLC", id: "ID1031910192" },
      { name: "American Opportunity Regional Center LLC", id: "RC2300002640" },
      { name: "American Venture Solutions Regional Center", id: "RC2200001124" },
      { name: "ARCG Florida Regional Center, LLC", id: "RC2300002351" },
      { name: "BC Central Florida Regional Center LLC", id: "RC2300002220" },
      { name: "BC Southeast Regional Center, LLC", id: "RC2300002181" },
      { name: "Clearwater Beach Resort Regional Center, LLC", id: "RC2200000637" },
      { name: "CMB Southeast Regional Center, LLC", id: "RC2200000173" },
      { name: "CREI Florida Regional Center, LLC", id: "RC2400008790" },
      { name: "EB5 Financing Management Company, LLC", id: "RC2200000441" },
      { name: "EB5 Florida Hotels & Investments Regional Center LLC", id: "RC2300001922" },
      { name: "EB5 Southeast RC LLC", id: "RC2200001131" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Education Fund SE LLC", id: "RC2300003974" },
      { name: "First America Florida LLC", id: "RC2400008953" },
      { name: "Florida EB5 Investments LLC", id: "RC2300001456" },
      { name: "Florida EB-5 Quantum Investments LLC", id: "RC2300001609" },
      { name: "Florida EB-5 Regional Center LLC", id: "RC2300002658" },
      { name: "Florida Equity & Growth Fund Regional Center LLC", id: "RC2200000375" },
      { name: "Florida First Regional Center LLC (former name USEGF Florida Regional Center)", id: "RC2300003347" },
      { name: "Florida Overseas Investment Center RC", id: "ID1031910161" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Gold Coast Florida Regional Center LLC", id: "RC2200000882" },
      { name: "Gulf Coast Regional Investment Center LLC", id: "RC2200000479" },
      { name: "Gulf States Regional Center LLC", id: "RC2200000295" },
      { name: "BC Southern Florida Regional Center, LLC", id: "RC2300002226" },
      { name: "LCP Florida Regional Center LLC", id: "RC2300003464" },
      { name: "My Florida Regional Center LLC DBA My EB5 Green Card Regional Center", id: "RC2300002366" },
      { name: "New Orleans & Gulf Coast Regional Center, LLC", id: "ID1216350684" },
      { name: "Orlando Regional Center, LLC", id: "RC2400009441" },
      { name: "Smith South Atlantic Regional Center", id: "RC2400008625" },
      { name: "EB5 Capital - Southeast Regional Center LLC", id: "RC2200000561" },
      { name: "Suncoast Growth Regional Center LLC", id: "RC2400009045" },
      { name: "Sunshine State Regional Center, Inc.", id: "RC2300001948" },
      { name: "EB5 Southeast Regional Center LLC (former name Greystone Florida Regional Center LLC)", id: "ID1215650675" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Dhanani EB-5 International, LLC", id: "RC2400008818" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "EB5AN Southeast Regional Center LLC", id: "RC2200000128" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "CanAm Florida Regional Center, LLC", id: "RC2200000123" },
    ],
  },
  "GA": {
    name: "Georgia",
    abbreviation: "GA",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "American Opportunity Regional Center LLC", id: "RC2300002640" },
      { name: "BC Southeast Regional Center, LLC", id: "RC2300002181" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "First America Florida LLC", id: "RC2400008953" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Suncoast Growth Regional Center LLC", id: "RC2400009045" },
      { name: "AHRC GA, LLC", id: "RC2200000487" },
      { name: "American Development Fund EB5, LLC", id: "RC2200000293" },
      { name: "Insignia Regional Center (former name American Investment and Immigration Center, LLC)", id: "RC2400008970" },
      { name: "American Pacific Regional Center", id: "RC2200000737" },
      { name: "American Real Estate Capital Group LLC", id: "RC2200000626" },
      { name: "Atlanta EB-5 Regional Center, LLC", id: "ID1031910163" },
      { name: "Carolina Global Regional Center Corporation", id: "RC2300002272" },
      { name: "CIG Southeast Regional Center LLC", id: "RC2200000751" },
      { name: "CMB Southeast Regional Center, LLC", id: "RC2200000173" },
      { name: "CTP Atlantic American Regional Center LLC", id: "RC2200000525" },
      { name: "Cumulus EB5 Foreign Investments, LLC", id: "RC2300003498" },
      { name: "EB5 Affiliate Network Southeast Regional Center LLC f/k/a Affiliate Network State of Georgia Regional Center LLC (former name EB5 Affiliate Network Southeast Regional Center, LLC)", id: "RC2200001155" },
      { name: "EB5 Southeast RC LLC", id: "RC2200001131" },
      { name: "EC Regional Center LLC", id: "RC2300005461" },
      { name: "Education Fund SE LLC", id: "RC2300003974" },
      { name: "GCFID LLC dba Georgia Center for Foreign Investment and Development", id: "RC2200001363" },
      { name: "Georgia Regional Center LLC", id: "RC2300002800" },
      { name: "Invest Atlanta Regional Center", id: "ID1502052555" },
      { name: "LD Capital SE Regional Center LLC", id: "RC2400009324" },
      { name: "MCFI Georgia Regional Center LLC", id: "ID1235250867" },
      { name: "Reentry Regional Center South, LLC", id: "RC2200001375" },
      { name: "Shyam Developers LLC", id: "RC2300002811" },
      { name: "Shoora Regional Center, LLC", id: "RC2300001972" },
      { name: "Smith South Atlantic Regional Center", id: "RC2400008625" },
      { name: "EB5 Capital - Southeast Regional Center LLC", id: "RC2200000561" },
      { name: "Southeast Foreign Investment Center LLC", id: "RC2400009025" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Southern States Regional Center LLC", id: "RC2300001647" },
      { name: "USCFID Georgia LLC", id: "RC2200001361" },
      { name: "Carolina Center for Foreign Investment, LLC aka Carolina Center for Foreign Investment Regional Center", id: "RC2300002603" },
      { name: "Dhanani EB-5 International, LLC", id: "RC2400008818" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "Georgia EB-5 Investments LLC", id: "RC2500015160" },
      { name: "CanAm Florida Regional Center, LLC", id: "RC2200000123" },
    ],
  },
  "HI": {
    name: "Hawaii",
    abbreviation: "HI",
    centers: [
      { name: "Advantage America Hawaii Regional Center LLC", id: "RC2400009308" },
      { name: "LCR Pacific Regional Center LLC", id: "RC2200000034" },
      { name: "CMB Hawaii Regional Center, LLC", id: "RC2300002019" },
      { name: "Hawaii Investment Regional Center Inc.", id: "RC2400010285" },
      { name: "Hawaii Economic Investment Center LLC", id: "RC2300003487" },
      { name: "CanAm Hawaii Regional Center, LLC", id: "RC2200000076" },
      { name: "Hawaii Islands EB-5 Regional Center LLC", id: "RC2300005530" },
      { name: "KCI Hawaii Regional Center", id: "ID1316951165" },
      { name: "LCP Hawaii Regional Center LLC", id: "RC2300003480" },
      { name: "Smith Hawaii Regional Center, LLC", id: "RC2200000408" },
      { name: "Lexden-Hawaii Regional Center, LLC", id: "ID1419751809" },
      { name: "Civitas Hawaii Regional Center, LLC", id: "RC2400009400" },
      { name: "New Hawaii Regional Center LLC", id: "RC2300005647" },
      { name: "AmCan American Regional Center LLC", id: "RC2400009727" },
      { name: "EB5 Group Hawaiian Islands Regional Center LLC", id: "RC2400009670" },
    ],
  },
  "ID": {
    name: "Idaho",
    abbreviation: "ID",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "Pine State Regional Center Northwest LLC", id: "RC2400009046" },
      { name: "ALC Rocky Mountain LLC", id: "RC2200000299" },
      { name: "EB5AN Rocky Mountain Regional Center LLC", id: "RC2200000438" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "Invest Idaho, LLC", id: "RC2300003970" },
      { name: "Newlifeplan LTD", id: "RC2300002650" },
      { name: "Pacific Northwest EB-5 Regional Center", id: "RC2200000234" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "ADF Mountain Regional Center LLC", id: "RC2400012337" },
      { name: "American Greenfield Regional Center LLC", id: "RC2400011778" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
    ],
  },
  "IL": {
    name: "Illinois",
    abbreviation: "IL",
    centers: [
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "ALC Great Lakes LLC", id: "RC2200000457" },
      { name: "American Ambition Regional Center Chicago, LLC", id: "ID1301751068" },
      { name: "Chicago JD Terra Regional Center LLC", id: "RC2300002053" },
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "Chicago Metro Regional Center Entity", id: "ID1129150336" },
      { name: "Civitas Midwest Regional Center LLC", id: "RC2300003713" },
      { name: "CMB Illinois Regional Center, LLC", id: "RC2200000208" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "CanAm Midwest Regional Center, LLC", id: "RC2300003481" },
      { name: "Freedom Partners Regional Center LLC", id: "ID1304251084" },
      { name: "GO EB5 RC Regional Center LLC", id: "RC2300002112" },
      { name: "Great Lakes Regional Center LLC", id: "RC2300001983" },
      { name: "Great Chicago Regional Center LLC (former name Keystone Great Lakes Regional Center LLC)", id: "ID1527453285" },
      { name: "LaSalle Street Regional Center LLC", id: "RC2200000829" },
      { name: "Mighty Rivers Regional Center", id: "RC2300002922" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Lakes Regional Center LLC", id: "RC2200000265" },
      { name: "Triton Global Capital LLC", id: "RC2300003355" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "Metropolitan Milwaukee Association of Commerce (MMAC) Regional Center LLC", id: "RC2300001670" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "Vectorfund, LLC", id: "RC2400009439" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "Pacifica Midwest Regional Center, LLC", id: "RC2400009245" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "IN": {
    name: "Indiana",
    abbreviation: "IN",
    centers: [
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Civitas Midwest Regional Center LLC", id: "RC2300003713" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "CanAm Midwest Regional Center, LLC", id: "RC2300003481" },
      { name: "ALC Great Lakes LLC", id: "RC2200000457" },
      { name: "Chicago JD Terra Regional Center LLC", id: "RC2300002053" },
      { name: "Bluegrass International Fund, LLC", id: "ID1410451731" },
      { name: "CMB Illinois Regional Center, LLC", id: "RC2200000208" },
      { name: "EB5 of Ohio, LLC", id: "ID1501652544" },
      { name: "Freedom Partners Regional Center LLC", id: "ID1304251084" },
      { name: "Great Lakes Regional Center LLC", id: "RC2300001983" },
      { name: "Great Chicago Regional Center LLC (former name Keystone Great Lakes Regional Center LLC)", id: "ID1527453285" },
      { name: "KOIT Global Investments LLC", id: "RC2300005104" },
      { name: "LaSalle Street Regional Center LLC", id: "RC2200000829" },
      { name: "Midwest Center for Foreign Investment, LLC", id: "ID1031910188" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Lakes Regional Center LLC", id: "RC2200000265" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "Vectorfund, LLC", id: "RC2400009439" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "IA": {
    name: "Iowa",
    abbreviation: "IA",
    centers: [
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "CMB Nebraska Regional Center LLC", id: "ID1312251130" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "KS": {
    name: "Kansas",
    abbreviation: "KS",
    centers: [
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "Kansas Regional Center", id: "ID1101050144" },
      { name: "Rural Economic Development Center LLC (formerly known as 1900 Gulf Street Partners Regional Center LLC)", id: "RC2300003315" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
    ],
  },
  "KY": {
    name: "Kentucky",
    abbreviation: "KY",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "Mighty Rivers Regional Center", id: "RC2300002922" },
      { name: "Bluegrass International Fund, LLC", id: "ID1410451731" },
      { name: "Bluegrass International Fund Regional Center, LLC", id: "ID1410451731" },
      { name: "EB5 of Ohio, LLC", id: "ID1501652544" },
      { name: "KOIT Global Investments LLC", id: "RC2300005104" },
      { name: "Live in America - South Regional Center LLC", id: "RC2200001398" },
      { name: "Midwest Center for Foreign Investment, LLC", id: "ID1031910188" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "West Virginia Regional Center, LLC", id: "RC2200000548" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
    ],
  },
  "LA": {
    name: "Louisiana",
    abbreviation: "LA",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Civitas Central Regional Center, LLC", id: "RC2300002995" },
      { name: "Smith Texarkana Regional Center, LLC", id: "RC2300003396" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "Central Southern Regional Center (former name USA South Regional Center)", id: "ID1428151909" },
      { name: "Crescent Regional Center, LLC", id: "RC2300001764" },
      { name: "iLand EB5 Regional Center, LLC", id: "RC2400009236" },
      { name: "Gulf Coast Regional Investment Center LLC", id: "RC2200000479" },
      { name: "Gulf States Regional Center LLC", id: "RC2200000295" },
      { name: "LD Capital LA Regional Center LLC", id: "ID1329551242" },
      { name: "New Orleans & Gulf Coast Regional Center, LLC", id: "ID1216350684" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "EB5 Capital - Southeast Regional Center LLC", id: "RC2200000561" },
      { name: "Southern Opportunity Regional Center LLC", id: "ID1419651808" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Fundmax, LLC", id: "RC2400009437" },
      { name: "Education Fund SC Regional Center", id: "RC2300003316" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "Vanguard Investment and Immigration WSC, LLC", id: "RC2500014390" },
    ],
  },
  "ME": {
    name: "Maine",
    abbreviation: "ME",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "MD": {
    name: "Maryland",
    abbreviation: "MD",
    centers: [
      { name: "CanAm Greater Washington Regional Center LLC (former name American Lending Center Virginia, LLC)", id: "RC2300001489" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "American Heritage Regional Center, LLC", id: "ID1525452912" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Birch Maryland GP LLC", id: "RC2200000497" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "Chesapeake Regional Center, LLC", id: "ID1306051099" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "Delaware Valley Regional Center, LLC", id: "RC2300001599" },
      { name: "EB5 Capital - DC Regional Center", id: "RC2200000001" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Live in America - Washington D.C./Baltimore Regional Center LLC", id: "RC2300001446" },
      { name: "Maryland Center for Foreign Investment, LLC", id: "ID1031910002" },
      { name: "Maryland Global Regional Center, LLC", id: "ID1335851436" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Milou Chesapeake Regional Center LLC (former name Oriental Dolphin EB-5 Regional Center)", id: "RC2300002524" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Tran EB5 Regional Center LLC", id: "RC2300005894" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
    ],
  },
  "MA": {
    name: "Massachusetts",
    abbreviation: "MA",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "Allstates QSR Regional Center, LLC", id: "RC2400008961" },
      { name: "Ashcroft Sullivan New England Economic Development Center", id: "ID1431151966" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Boston Regional Center Inc", id: "RC2300003131" },
      { name: "Civitas Massachusetts Regional Center LLC", id: "RC2300001798" },
      { name: "EB5AN MA and Northeast Regional Center LLC", id: "RC2300001957" },
      { name: "EB-5 Jobs for Massachusetts, Inc.", id: "ID1031910110" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "New England Regional Center for Economic Development Inc.", id: "RC2300005127" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "Sunpin Massachusetts Regional Center, LLC", id: "ID1422351846" },
      { name: "TOEC Regional Center LLC", id: "ID1504452595" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "New England EB5 Regional Center LLC", id: "RC2300005197" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "MI": {
    name: "Michigan",
    abbreviation: "MI",
    centers: [
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Civitas Midwest Regional Center LLC", id: "RC2300003713" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "CanAm Midwest Regional Center, LLC", id: "RC2300003481" },
      { name: "ALC Great Lakes LLC", id: "RC2200000457" },
      { name: "International Partners of Michigan LLP (former name International Michigan Investment Regional Center)", id: "RC2300006186" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Lakes Regional Center LLC", id: "RC2200000265" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "MN": {
    name: "Minnesota",
    abbreviation: "MN",
    centers: [
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "International Creative Capital LLC", id: "RC2300002191" },
      { name: "North Dakota Minnesota EB-5 Regional Center, LLC (former name North Dakota/Minnesota EB-5 Regional Center)", id: "RC2400008481" },
      { name: "CMB Minnesota Regional Center LLC", id: "ID1514652723" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
    ],
  },
  "MS": {
    name: "Mississippi",
    abbreviation: "MS",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Mid America Fund LLC", id: "RC2300004564" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "EB5 Affiliate Network Southeast Regional Center LLC f/k/a Affiliate Network State of Georgia Regional Center LLC (former name EB5 Affiliate Network Southeast Regional Center, LLC)", id: "RC2200001155" },
      { name: "Encore Mississippi Regional Center", id: "ID1218450699" },
      { name: "Gulf Coast Regional Investment Center LLC", id: "RC2200000479" },
      { name: "Gulf States Regional Center LLC", id: "RC2200000295" },
      { name: "Mississippi Development Regional Center, LLC", id: "RC2400008978" },
      { name: "New Orleans & Gulf Coast Regional Center, LLC", id: "ID1216350684" },
      { name: "Reentry Regional Center South, LLC", id: "RC2200001375" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "EB5 Capital - Southeast Regional Center LLC", id: "RC2200000561" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
    ],
  },
  "MO": {
    name: "Missouri",
    abbreviation: "MO",
    centers: [
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "Mighty Rivers Regional Center", id: "RC2300002922" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "Pine State Regional Center, LLC", id: "RC2200000036" },
      { name: "Rural Economic Development Center LLC (formerly known as 1900 Gulf Street Partners Regional Center LLC)", id: "RC2300003315" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "MT": {
    name: "Montana",
    abbreviation: "MT",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Rosewood Regional Center LLC", id: "RC2400009182" },
      { name: "ALC Rocky Mountain LLC", id: "RC2200000299" },
      { name: "EB5AN Rocky Mountain Regional Center LLC", id: "RC2200000438" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "NewGen MT Regional Center LLC", id: "RC2200000506" },
      { name: "Northern Rockies Regional Center", id: "RC2200000746" },
      { name: "Pacific Northwest EB-5 Regional Center", id: "RC2200000234" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Civitas North Central Regional Center LLC", id: "RC2400009407" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "American Greenfield Regional Center LLC", id: "RC2400011778" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
    ],
  },
  "NE": {
    name: "Nebraska",
    abbreviation: "NE",
    centers: [
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "CMB Nebraska Regional Center LLC", id: "ID1312251130" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "Civitas North Central Regional Center LLC", id: "RC2400009407" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
    ],
  },
  "NV": {
    name: "Nevada",
    abbreviation: "NV",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "LCP Southwest Regional Center LLC", id: "RC2400006580" },
      { name: "Admiralty Sierra Regional Center, LLC", id: "RC2300005725" },
      { name: "Advantage America California Regional Center, LLC", id: "RC2300005772" },
      { name: "Alka Empire Regional Center LLC", id: "RC2300004748" },
      { name: "JKML Regional Center LLC", id: "RC2400008845" },
      { name: "Monterey Northern California Regional Center, LLC", id: "RC2300002531" },
      { name: "Pine State Regional Center Northwest LLC", id: "RC2400009046" },
      { name: "WC Regional Center LLC", id: "RC2300005222" },
      { name: "Invest Idaho, LLC", id: "RC2300003970" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "ALC West LLC", id: "RC2200000407" },
      { name: "ARCG Nevada Regional Center LLC (former name Geothermal Regional Center LLC)", id: "RC2300002370" },
      { name: "Awesome American Regional Center LLC", id: "RC2300001570" },
      { name: "Civitas Las Vegas Regional Center LLC", id: "RC2300001804" },
      { name: "Landmark Development Partners LLC dba Clark County Regional Center", id: "RC2300004483" },
      { name: "CMB Export LLC", id: "RC2200000040" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "EB5 Prime, LLC", id: "RC2400008575" },
      { name: "EB-5 Impact Capital Regional Center, LLC", id: "ID1410551734" },
      { name: "New Course West Regional Center LLC", id: "RC2200001128" },
      { name: "Happy Family USA Regional Center", id: "ID1527153031" },
      { name: "Las Vegas Economic Impact Regional Center, LLC", id: "ID1126250313" },
      { name: "American Dream Fund LLC dba Las Vegas Regional Center", id: "RC2300002101" },
      { name: "Nevada Investment Regional Center, LLC", id: "ID1407651709" },
      { name: "Nevada Regional Economic Development Center LLC", id: "RC2300003741" },
      { name: "Pacific Casino & Entertainment Group Ltd", id: "ID1302551074" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "Vegas Regional Center, LLC", id: "ID1625654407" },
      { name: "Zephyrus Regional Center LLC", id: "ID1636255049" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "EB5AN Far West Regional Center LLC", id: "RC2200000215" },
      { name: "Businvest, LLC", id: "RC2400009319" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "USA Education Fund Nevada Regional Center LLC", id: "RC2300002385" },
      { name: "EB5 Group Western States Regional Center LLC", id: "RC2400009668" },
      { name: "American Innovation West Coast Regional Center LLC", id: "RC2400009772" },
      { name: "ADF Mountain Regional Center LLC", id: "RC2400012337" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
      { name: "Akal Development Inc.", id: "RC2500015991" },
    ],
  },
  "NH": {
    name: "New Hampshire",
    abbreviation: "NH",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "New England Regional Center for Economic Development Inc.", id: "RC2300005127" },
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Green Mountain Regional Center LLC", id: "RC2300002084" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Invest New Hampshire Regional Center, LLC", id: "ID1121350256" },
      { name: "New Hampshire EB-5 Regional Center", id: "ID1031910083" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "TOEC Regional Center LLC", id: "ID1504452595" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "New England EB5 Regional Center LLC", id: "RC2300005197" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "NJ": {
    name: "New Jersey",
    abbreviation: "NJ",
    centers: [
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "NY Hudson Capital Partners LLC", id: "RC2400008901" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "USANY Regional Center LLC", id: "RC2300005057" },
      { name: "A 1 Regional Center", id: "RC2200001023" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "American EB-5 Properties Regional Center, LLC", id: "ID1435652190" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "American Regional Center for Entrepreneurs Inc (dba ARCFE)", id: "RC2200000292" },
      { name: "American Regional Center Opportunity Fund LLC", id: "RC2300003894" },
      { name: "AscendAmerica LLC", id: "RC2200000422" },
      { name: "Atlantic City Regional Center, LLC (d/b/a Princeton Global Capital Fund, LLC)", id: "ID1127950330" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "CUCC Business Regional Center, Inc (former name U.S. Business Regional Center Inc.)", id: "RC2300002199" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Delaware Valley Regional Center, LLC", id: "RC2300001599" },
      { name: "East Coast Regional Center, LLC", id: "RC2300004768" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "EB5 Capital - New York Regional Center LLC", id: "RC2300002093" },
      { name: "BTM Greater NY Regional Center, Inc.", id: "RC2200001378" },
      { name: "EB5 Opportunities Fund, LLC", id: "RC2400009337" },
      { name: "Empire Regional Center, LLC", id: "ID1414151760" },
      { name: "Global City Regional Center LLC", id: "RC2300001493" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Harmonia Regional Center New York", id: "ID1516152743" },
      { name: "Hudson Funds New York Regional Center, LLC", id: "ID1635754956" },
      { name: "LCR Overseas Regional Center LLC", id: "RC2300002338" },
      { name: "EB5 Northeast RC, LLC (former name Liberty Harbor Regional Center, LLC)", id: "RC2300002355" },
      { name: "Lightstone New York Regional Center LLC", id: "RC2300001784" },
      { name: "Live in America - New York Regional Center LLC", id: "RC2300001469" },
      { name: "LUC Capital, LLC", id: "RC2300001605" },
      { name: "Manhattan Metropolitan Regional Center", id: "ID1501652543" },
      { name: "MZH Capital Partners, Inc.", id: "ID1533653487" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Midtown NYC Regional Center, LLC", id: "RC2300003738" },
      { name: "Mugo Regional Center LLC", id: "ID1610954307" },
      { name: "New Empire EB-5 Regional Center, LLC", id: "RC2400009359" },
      { name: "New York City EB-5, LLC", id: "RC2300003358" },
      { name: "New York City Real Estate Regional Center, LLC", id: "ID1120950252" },
      { name: "New York City Transportation Regional Center LLC", id: "RC2300004603" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "NY Entrepreneurs Fund, LLC", id: "RC2300003467" },
      { name: "NYC Liberty Green Regional Center, LLC", id: "ID1635854999" },
      { name: "Related New York City Metro Regional Center, LLC", id: "ID1316851164" },
      { name: "Smith North Atlantic Regional Center LLC", id: "RC2200000360" },
      { name: "Northern Regional Center LLC", id: "RC2300002271" },
      { name: "United Land RC LLC", id: "RC2300001945" },
      { name: "USCFID New York LLC", id: "RC2200001395" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Civitas New York Regional Center, LLC", id: "RC2300001834" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "Metropolis Regional Center, LLC", id: "RC2400009628" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "Liberty Gateway Regional Center LLC", id: "RC2400006261" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "NM": {
    name: "New Mexico",
    abbreviation: "NM",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "Green Card Fund LLC", id: "RC2200000141" },
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "Rosewood Regional Center LLC", id: "RC2400009182" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "American Lending Center Southwest LLC", id: "RC2200000169" },
      { name: "Civitas El Paso Regional Center LLC", id: "RC2300001840" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "EB5AN Southwest Regional Center LLC", id: "RC2200000238" },
      { name: "iLand EB5 Regional Center, LLC", id: "RC2400009236" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Southwest EB5 Regional Center LLC", id: "RC2400009661" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "EB5 Southwest RC LLC", id: "RC2400012362" },
      { name: "Education Fund SC Regional Center", id: "RC2300003316" },
      { name: "Great American Southwest Regional Center LLC", id: "RC2400009672" },
      { name: "EB5 Group Southwestern States Regional Center LLC", id: "RC2400009665" },
      { name: "Texas Lending Alliance, LLC", id: "RC2500014075" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
    ],
  },
  "NY": {
    name: "New York",
    abbreviation: "NY",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "NY Hudson Capital Partners LLC", id: "RC2400008901" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "USANY Regional Center LLC", id: "RC2300005057" },
      { name: "A 1 Regional Center", id: "RC2200001023" },
      { name: "Advantage America New York Regional Center, LLC", id: "RC2200001200" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "Allstates QSR Regional Center, LLC", id: "RC2400008961" },
      { name: "American EB-5 Properties Regional Center, LLC", id: "ID1435652190" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "American Regional Center for Entrepreneurs Inc (dba ARCFE)", id: "RC2200000292" },
      { name: "American Regional Center Opportunity Fund LLC", id: "RC2300003894" },
      { name: "AscendAmerica LLC", id: "RC2200000422" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Civitas New York Regional Center, LLC", id: "RC2300001834" },
      { name: "CUCC Business Regional Center, Inc (former name U.S. Business Regional Center Inc.)", id: "RC2300002199" },
      { name: "East Coast Regional Center, LLC", id: "RC2300004768" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "EB5 Capital - New York Regional Center LLC", id: "RC2300002093" },
      { name: "BTM Greater NY Regional Center, Inc.", id: "RC2200001378" },
      { name: "EB-5 New York State, LLC", id: "RC2200000035" },
      { name: "EB5 Opportunities Fund, LLC", id: "RC2400009337" },
      { name: "Empire Regional Center, LLC", id: "ID1414151760" },
      { name: "Extell New York Regional Center", id: "ID1101250146" },
      { name: "Fleet New York Metropolitan Regional Center LLC (former name Federal New York Metropolitan Regional Center)", id: "ID1031910196" },
      { name: "Greater New York Regional Center LLC", id: "RC2300003533" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Harmonia Regional Center New York", id: "ID1516152743" },
      { name: "Hudson Funds New York Regional Center, LLC", id: "ID1635754956" },
      { name: "Lam NYC EB-5 Fund Regional Center LLC", id: "RC2300003708" },
      { name: "LCR Overseas Regional Center LLC", id: "RC2300002338" },
      { name: "EB5 Northeast RC, LLC (former name Liberty Harbor Regional Center, LLC)", id: "RC2300002355" },
      { name: "Lightstone New York Regional Center LLC", id: "RC2300001784" },
      { name: "Live in America - New York Regional Center LLC", id: "RC2300001469" },
      { name: "LUC Capital, LLC", id: "RC2300001605" },
      { name: "Manhattan Metropolitan Regional Center", id: "ID1501652543" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Midtown NYC Regional Center, LLC", id: "RC2300003738" },
      { name: "Mugo Regional Center LLC", id: "ID1610954307" },
      { name: "New Empire EB-5 Regional Center, LLC", id: "RC2400009359" },
      { name: "New York City EB-5, LLC", id: "RC2300003358" },
      { name: "New York City Real Estate Regional Center, LLC", id: "ID1120950252" },
      { name: "New York City Regional Center, LLC", id: "RC2300001596" },
      { name: "New York City Transportation Regional Center LLC", id: "RC2300004603" },
      { name: "New York Dream Regional Center LLC (former name Tri-State USA Regional Center)", id: "RC2300003767" },
      { name: "New York Connecticut Regional Center, LLC", id: "RC2300001575" },
      { name: "New York EB-5 Regional Center, LLC", id: "RC2300003737" },
      { name: "New York Immigration Fund, LLC", id: "RC2300002072" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "NY Entrepreneurs Fund, LLC", id: "RC2300003467" },
      { name: "NYC Liberty Green Regional Center, LLC", id: "ID1635854999" },
      { name: "NYC Mayflower Regional Center, INC", id: "ID1208850623" },
      { name: "NYC Metro Regional Center, LLC", id: "ID1034750121" },
      { name: "NYC Regional Center, Inc", id: "RC2300003128" },
      { name: "NYUS Regional Center", id: "RC2300001779" },
      { name: "NYUS Terra LLC", id: "RC2400009721" },
      { name: "Prime Regional Center LLC d/b/a Great NY Regional Center", id: "RC2300002971" },
      { name: "Related New York City Metro Regional Center, LLC", id: "ID1316851164" },
      { name: "Smith North Atlantic Regional Center LLC", id: "RC2200000360" },
      { name: "Northern Regional Center LLC", id: "RC2300002271" },
      { name: "U.S. Immigration Fund - NY LLC", id: "RC2300001984" },
      { name: "United Land RC LLC", id: "RC2300001945" },
      { name: "USCFID New York LLC", id: "RC2200001395" },
      { name: "Veria Regional Center, Inc.", id: "ID1407051702" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "Metropolis Regional Center, LLC", id: "RC2400009628" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "Liberty Gateway Regional Center LLC", id: "RC2400006261" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "NC": {
    name: "North Carolina",
    abbreviation: "NC",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "First America Florida LLC", id: "RC2400008953" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Suncoast Growth Regional Center LLC", id: "RC2400009045" },
      { name: "Shyam Developers LLC", id: "RC2300002811" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "American Lending Center North Carolina, LLC", id: "RC2200000120" },
      { name: "Appalachian EB-5 LLC", id: "RC2200000221" },
      { name: "Atlantic Regional Center for Foreign Investment, LLC", id: "ID1031910189" },
      { name: "CMB North Carolina Regional Center LLC", id: "RC2200000184" },
      { name: "Carolina Center for Foreign Investment, LLC aka Carolina Center for Foreign Investment Regional Center", id: "RC2300002603" },
      { name: "Carolina Global Regional Center Corporation", id: "RC2300002272" },
      { name: "Carolina Growth Regional Center, LLC", id: "RC2400009058" },
      { name: "American Real Estate Capital Group LLC", id: "RC2200000626" },
      { name: "CTP Atlantic American Regional Center LLC", id: "RC2200000525" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Education Fund SE LLC", id: "RC2300003974" },
      { name: "EiPG Carolinas Regional Center, LLC", id: "RC2300005720" },
      { name: "Greater Carolina Regional Center LLC", id: "RC2400008186" },
      { name: "Live in America - Carolinas Regional Center LLC", id: "RC2200001367" },
      { name: "RSR EB-5 Regional Center, LLC", id: "RC2400011572" },
      { name: "Smith South Atlantic Regional Center", id: "RC2400008625" },
      { name: "Venus RC LLC", id: "RC2300003764" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Lighthouse Carolinas Regional Center LLC", id: "RC2400009133" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "CanAm Florida Regional Center, LLC", id: "RC2200000123" },
    ],
  },
  "ND": {
    name: "North Dakota",
    abbreviation: "ND",
    centers: [
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "North Dakota Minnesota EB-5 Regional Center, LLC (former name North Dakota/Minnesota EB-5 Regional Center)", id: "RC2400008481" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "Civitas North Central Regional Center LLC", id: "RC2400009407" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
    ],
  },
  "OH": {
    name: "Ohio",
    abbreviation: "OH",
    centers: [
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Civitas Midwest Regional Center LLC", id: "RC2300003713" },
      { name: "CanAm Midwest Regional Center, LLC", id: "RC2300003481" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "ALC Great Lakes LLC", id: "RC2200000457" },
      { name: "American Lending Center Ohio LLC", id: "RC2300001485" },
      { name: "Cloudseed International Fund, LLC", id: "ID1332651295" },
      { name: "CMB Summit LLC RC", id: "ID1031910107" },
      { name: "EB5 of Ohio, LLC", id: "ID1501652544" },
      { name: "KOIT Global Investments LLC", id: "RC2300005104" },
      { name: "Mag Ventures 2, LLC", id: "RC2300002213" },
      { name: "Mag Ventures 3, LLC", id: "RC2200000499" },
      { name: "Midwestern Investments For America, LLC", id: "ID1400951638" },
      { name: "Ohio International Investment Center", id: "ID1421251834" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Lakes Regional Center LLC", id: "RC2200000265" },
      { name: "Texo Capital, LLC", id: "RC2300002145" },
      { name: "West Virginia Regional Center, LLC", id: "RC2200000548" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "Monad Regional Center LLC", id: "RC2400009562" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
    ],
  },
  "OK": {
    name: "Oklahoma",
    abbreviation: "OK",
    centers: [
      { name: "EB5 Capital – Texas Regional Center, LLC", id: "RC2300004915" },
      { name: "Civitas Central Regional Center, LLC", id: "RC2300002995" },
      { name: "Smith Texarkana Regional Center, LLC", id: "RC2300003396" },
      { name: "Asian Physicians & Professional EB5 Regional Center LLC", id: "RC2300005502" },
      { name: "Biz51 Group Regional Center LLC", id: "RC2300003696" },
      { name: "Green Pathway Regional Center, LLC", id: "RC2300004593" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "American Lending Center Southwest LLC", id: "RC2200000169" },
      { name: "Central Southern Regional Center (former name USA South Regional Center)", id: "ID1428151909" },
      { name: "Champion EB5 Regional Center LLC", id: "RC2400008335" },
      { name: "EB5AN Southwest Regional Center LLC", id: "RC2200000238" },
      { name: "Oklahoma State Regional Center, LLC", id: "RC2300002534" },
      { name: "Global Crossing, LLC (former name Smith Mountain Regional Center, LLC)", id: "RC2300003985" },
      { name: "Western Energy Regional Center LLC", id: "RC2200000150" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "Greater Sulphur Springs Regional Center, LLC", id: "RC2300003440" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southwest Regional Center LLC", id: "RC2400009672" },
      { name: "EB5 Group Southwestern States Regional Center LLC", id: "RC2400009665" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
      { name: "Global Gateway LLC", id: "RC2400011753" },
      { name: "Vanguard Investment and Immigration WSC, LLC", id: "RC2500014390" },
    ],
  },
  "OR": {
    name: "Oregon",
    abbreviation: "OR",
    centers: [
      { name: "CanAm California Regional Center LLC (former name CanAm Los Angeles Conty Regional Center and Los Angeles Film Regional Center)", id: "RC2200000080" },
      { name: "Civitas Pacific Regional Center LLC", id: "RC2300003456" },
      { name: "Live in America – California Regional Center LLC", id: "RC2400006717" },
      { name: "Pacific Coast USA Regional Center LLC", id: "RC2300002990" },
      { name: "Pine State Regional Center Northwest LLC", id: "RC2400009046" },
      { name: "SPI EB5 Pacific RC, LLC", id: "RC2200000409" },
      { name: "Newlifeplan LTD", id: "RC2300002650" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "ALC West LLC", id: "RC2200000407" },
      { name: "American Renewable Energy Investments Regional Center, LLC", id: "RC2400008887" },
      { name: "American United Development Group LLC", id: "RC2200000744" },
      { name: "Cascadia Regional Center", id: "RC2200000196" },
      { name: "EB5AN WA OR and Northern Plains Regional Center LLC", id: "RC2300001761" },
      { name: "EB5 Capital - California Regional Center LLC", id: "RC2200000007" },
      { name: "Pacific Northwest EB-5 Regional Center", id: "RC2200000234" },
      { name: "American Dream Fund dba Portland Regional Center", id: "ID1031910047" },
      { name: "Redwood Regional Center, LLC", id: "ID1634954742" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "West Coast EB5 Regional Center, LLC", id: "RC2200001186" },
      { name: "Zephyrus Regional Center LLC", id: "ID1636255049" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "EB5AN Far West Regional Center LLC", id: "RC2200000215" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "EB5 Group Western States Regional Center LLC", id: "RC2400009668" },
      { name: "American Innovation West Coast Regional Center LLC", id: "RC2400009772" },
    ],
  },
  "PA": {
    name: "Pennsylvania",
    abbreviation: "PA",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "USANY Regional Center LLC", id: "RC2300005057" },
      { name: "East Coast Regional Center, LLC", id: "RC2300004768" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "Texo Capital, LLC", id: "RC2300002145" },
      { name: "A 1 Regional Center", id: "RC2200001023" },
      { name: "AHRC PA, LLC", id: "ID1627454453" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "Allstates QSR Regional Center, LLC", id: "RC2400008961" },
      { name: "ALC Mideast LLC", id: "RC2200000303" },
      { name: "American Oil Group, LLC d/b/a American Oil Regional Center", id: "ID1229850792" },
      { name: "American Regional Center for Entrepreneurs Inc (dba ARCFE)", id: "RC2200000292" },
      { name: "American Regional Center Opportunity Fund LLC", id: "RC2300003894" },
      { name: "AscendAmerica LLC", id: "RC2200000422" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "Delaware Valley Regional Center, LLC", id: "RC2300001599" },
      { name: "EB5 Capital - New York Regional Center LLC", id: "RC2300002093" },
      { name: "EB5 Opportunities Fund, LLC", id: "RC2400009337" },
      { name: "Global City Regional Center LLC", id: "RC2300001493" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Hudson Funds New York Regional Center, LLC", id: "ID1635754956" },
      { name: "LCR Overseas Regional Center LLC", id: "RC2300002338" },
      { name: "EB5 Northeast RC, LLC (former name Liberty Harbor Regional Center, LLC)", id: "RC2300002355" },
      { name: "Lightstone New York Regional Center LLC", id: "RC2300001784" },
      { name: "Live in America - New York Regional Center LLC", id: "RC2300001469" },
      { name: "LUC Capital, LLC", id: "RC2300001605" },
      { name: "Mid-Atlantic Regional Center", id: "ID1434252044" },
      { name: "Mugo Regional Center LLC", id: "ID1610954307" },
      { name: "New Empire EB-5 Regional Center, LLC", id: "RC2400009359" },
      { name: "New York City EB-5, LLC", id: "RC2300003358" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "NYC Liberty Green Regional Center, LLC", id: "ID1635854999" },
      { name: "CanAm Pennsylvania Regional Center, LLC", id: "RC2200000247" },
      { name: "CanAm PIDC Regional Center LLC", id: "RC2200000037" },
      { name: "Related New York City Metro Regional Center, LLC", id: "ID1316851164" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith North Atlantic Regional Center LLC", id: "RC2200000360" },
      { name: "Northern Regional Center LLC", id: "RC2300002271" },
      { name: "Texo Capital, LLC", id: "ID1605054256" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "United Land RC LLC", id: "RC2300001945" },
      { name: "USCFID New York LLC", id: "RC2200001395" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "Liberty Gateway Regional Center LLC", id: "RC2400006261" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "PR": {
    name: "Puerto Rico",
    abbreviation: "PR",
    centers: [
      { name: "EB5AN Non-Continental Regional Center, LLC", id: "RC2300001545" },
      { name: "Iconic Caribbean EB-5 LLC", id: "RC2300001686" },
    ],
  },
  "RI": {
    name: "Rhode Island",
    abbreviation: "RI",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "Civitas Northeast Regional Center LLC", id: "RC2300003508" },
      { name: "EB5 United Northeast Regional Center, LLC", id: "RC2400009132" },
      { name: "NYNJ Regional Center LLC", id: "RC2400007982" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "Ashcroft Sullivan New England Economic Development Center", id: "ID1431151966" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "New England Regional Center for Economic Development Inc.", id: "RC2300005127" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "TOEC Regional Center LLC", id: "ID1504452595" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "New England EB5 Regional Center LLC", id: "RC2300005197" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "SC": {
    name: "South Carolina",
    abbreviation: "SC",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "First America Florida LLC", id: "RC2400008953" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Suncoast Growth Regional Center LLC", id: "RC2400009045" },
      { name: "Shyam Developers LLC", id: "RC2300002811" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "EiPG Carolinas Regional Center, LLC", id: "RC2300005720" },
      { name: "Venus RC LLC", id: "RC2300003764" },
      { name: "American Lending Center North Carolina, LLC", id: "RC2200000120" },
      { name: "Carolina Center for Foreign Investment, LLC aka Carolina Center for Foreign Investment Regional Center", id: "RC2300002603" },
      { name: "Carolina Global Regional Center Corporation", id: "RC2300002272" },
      { name: "American Real Estate Capital Group LLC", id: "RC2200000626" },
      { name: "Appalachian EB-5 LLC", id: "RC2200000221" },
      { name: "CIG Southeast Regional Center LLC", id: "RC2200000751" },
      { name: "CTP Atlantic American Regional Center LLC", id: "RC2200000525" },
      { name: "EB5 Affiliate Network Southeast Regional Center LLC f/k/a Affiliate Network State of Georgia Regional Center LLC (former name EB5 Affiliate Network Southeast Regional Center, LLC)", id: "RC2200001155" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Education Fund SE LLC", id: "RC2300003974" },
      { name: "CMB South Carolina Regional Center LLC", id: "ID1527853355" },
      { name: "Live in America - Carolinas Regional Center LLC", id: "RC2200001367" },
      { name: "RSR EB-5 Regional Center, LLC", id: "RC2400011572" },
      { name: "Smith South Atlantic Regional Center", id: "RC2400008625" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Lighthouse Carolinas Regional Center LLC", id: "RC2400009133" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "Pacifica South Carolina Regional Center, LLC", id: "RC2400009238" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "Georgia EB-5 Investments LLC", id: "RC2500015160" },
      { name: "CanAm Florida Regional Center, LLC", id: "RC2200000123" },
    ],
  },
  "SD": {
    name: "South Dakota",
    abbreviation: "SD",
    centers: [
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "ALC Great Plains LLC", id: "RC2200000307" },
      { name: "Smith Great Plains Regional Center LLC", id: "RC2200000365" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "Civitas North Central Regional Center LLC", id: "RC2400009407" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "EB5 Capital – Central Regional Center LLC", id: "RC2400006433" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
    ],
  },
  "TN": {
    name: "Tennessee",
    abbreviation: "TN",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Smoky Mountain Regional Center LLC", id: "RC2400006421" },
      { name: "Mid America Fund LLC", id: "RC2300004564" },
      { name: "BC Southeast Regional Center, LLC", id: "RC2300002181" },
      { name: "EC Regional Center LLC", id: "RC2300005461" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Mighty Rivers Regional Center", id: "RC2300002922" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "American Real Estate Capital Group LLC", id: "RC2200000626" },
      { name: "Appalachian EB-5 LLC", id: "RC2200000221" },
      { name: "EB5 Affiliate Network Southeast Regional Center LLC f/k/a Affiliate Network State of Georgia Regional Center LLC (former name EB5 Affiliate Network Southeast Regional Center, LLC)", id: "RC2200001155" },
      { name: "EB5 Capital – Midwest Regional Center LLC (former name Encore Nashville RC, LLC)", id: "RC2300003502" },
      { name: "KOIT Global Investments LLC", id: "RC2300005104" },
      { name: "LD Capital SE Regional Center LLC", id: "RC2400009324" },
      { name: "Live in America - South Regional Center LLC", id: "RC2200001398" },
      { name: "Pine State Regional Center, LLC", id: "RC2200000036" },
      { name: "Reentry Regional Center South, LLC", id: "RC2200001375" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "Dhanani EB-5 International, LLC", id: "RC2400008818" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
    ],
  },
  "TX": {
    name: "Texas",
    abbreviation: "TX",
    centers: [
      { name: "Green Card Fund LLC", id: "RC2200000141" },
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "EB5 Capital – Texas Regional Center, LLC", id: "RC2300004915" },
      { name: "Civitas Central Regional Center, LLC", id: "RC2300002995" },
      { name: "Smith Texarkana Regional Center, LLC", id: "RC2300003396" },
      { name: "Asian Physicians & Professional EB5 Regional Center LLC", id: "RC2300005502" },
      { name: "Biz51 Group Regional Center LLC", id: "RC2300003696" },
      { name: "Green Pathway Regional Center, LLC", id: "RC2300004593" },
      { name: "EB-5 Inc Regional Center, LLC", id: "RC2400009214" },
      { name: "Southeast Regional Center LLC", id: "RC2300002263" },
      { name: "Crescent Regional Center, LLC", id: "RC2300001764" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "Champion EB5 Regional Center LLC", id: "RC2400008335" },
      { name: "Smith Delta Regional Center, LLC", id: "RC2400008710" },
      { name: "Makaan Texas Regional Center (former name Abasto Regional Center)", id: "RC2400008544" },
      { name: "ADF Texas Regional Center, LLC", id: "RC2300003820" },
      { name: "American Lending Center Southwest LLC", id: "RC2200000169" },
      { name: "American Regional Center LLC", id: "RC2300001536" },
      { name: "B US DEVELOPER LLC", id: "ID1318651172" },
      { name: "American Capital Regional Center LLC", id: "RC2300004501" },
      { name: "American Fortune Regional Center, LLC", id: "RC2400009358" },
      { name: "Ameri-Link Capital, LLC", id: "ID1129250338" },
      { name: "Austin EB5, LLC", id: "RC2300006041" },
      { name: "CanAm Texas Regional Center", id: "RC2200000244" },
      { name: "Central Regional Center, LLC", id: "RC2300005192" },
      { name: "Central Southern Regional Center (former name USA South Regional Center)", id: "ID1428151909" },
      { name: "City of Dallas Regional Center", id: "RC2300001816" },
      { name: "Civitas El Paso Regional Center LLC", id: "RC2300001840" },
      { name: "Civitas Texas Regional Center", id: "RC2300001810" },
      { name: "CMB Regional Centers Texas LLC", id: "RC2200000052" },
      { name: "Dhanani EB-5 International, LLC", id: "RC2400008818" },
      { name: "EB5AN Southwest Regional Center LLC", id: "RC2200000238" },
      { name: "iLand EB5 Regional Center, LLC", id: "RC2400009236" },
      { name: "Encore Texas RC LLC", id: "RC2400009635" },
      { name: "UCDA North Texas Regional Center, LLC", id: "RC2200000098" },
      { name: "GS SA EB5 LLC", id: "RC2300004741" },
      { name: "Great Southwest Regional Center LLC", id: "RC2300001791" },
      { name: "Great Texas Regional Center LLC", id: "RC2300001874" },
      { name: "Greater Sulphur Springs Regional Center, LLC", id: "RC2300003440" },
      { name: "Guardian Regional Center LLC", id: "RC2300001871" },
      { name: "Gulf States Regional Center LLC", id: "RC2200000295" },
      { name: "Harmonia Regional Center, LLC", id: "ID1418451798" },
      { name: "DC Partners LLC (dba Houston EB 5 Regional Center)", id: "RC2200000025" },
      { name: "JMIR Texas Mega Metro Regional Center, LLC", id: "ID1406651700" },
      { name: "LCR Dallas Metro Regional Center, LLC", id: "RC2200000250" },
      { name: "Lighthouse Regional Center LLC", id: "RC2400009056" },
      { name: "Live in America - Texas Regional Center LLC", id: "RC2200001199" },
      { name: "Makaan Regional Center, LLC", id: "RC2300002699" },
      { name: "McAllen EB-5 Regional Center LLC", id: "RC2400009043" },
      { name: "National EB-5 Wealth Center, LLC", id: "RC2300001432" },
      { name: "NM Texas Land and Property Developers LLC", id: "RC2300002614" },
      { name: "North Texas EB-5 Regional Center LLC", id: "ID1031910203" },
      { name: "Quality EB5 Inc.", id: "RC2400008677" },
      { name: "Robstown Improvement Development Corporation EB-5 Regional Center", id: "ID1033650023" },
      { name: "Global Crossing, LLC (former name Smith Mountain Regional Center, LLC)", id: "RC2300003985" },
      { name: "Southern Opportunity Regional Center LLC", id: "ID1419651808" },
      { name: "Texas Redevelopment Authority LLC", id: "RC2300005536" },
      { name: "Gia Capital LLC", id: "RC2300001956" },
      { name: "Texan Regional Center, LLC", id: "ID1331251277" },
      { name: "Texas Coast Regional Center Corporation", id: "RC2300001793" },
      { name: "Texas Crown Regional Center, LLC", id: "RC2300001452" },
      { name: "Texas Growth Fund Regional Center, LLC", id: "RC2400009083" },
      { name: "Texas Regional Center, LLC", id: "RC2300002295" },
      { name: "Texas Regional Fortune Center, LLC", id: "ID1213750656" },
      { name: "EB5 & Company LLC", id: "ID1517352753" },
      { name: "State Wide EB-5 Regional Center LLC", id: "RC2300005020" },
      { name: "The Winners Regional Center LLC", id: "RC2400009034" },
      { name: "Urban Heights TX EB5 Regional Center, LLC", id: "RC2400009335" },
      { name: "USA Education Fund LLC", id: "RC2200001404" },
      { name: "USLiving Regional Center", id: "ID1313651139" },
      { name: "Vistar's EB-5 Business Alliance of Texas LLC", id: "RC2200001104" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "Southwest EB5 Regional Center LLC", id: "RC2400009661" },
      { name: "QBS Regional Center LLC", id: "RC2400009900" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Fundmax, LLC", id: "RC2400009437" },
      { name: "EB5 Southwest RC LLC", id: "RC2400012362" },
      { name: "Education Fund SC Regional Center", id: "RC2300003316" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southwest Regional Center LLC", id: "RC2400009672" },
      { name: "EB5 Group Southwestern States Regional Center LLC", id: "RC2400009665" },
      { name: "Texas Lending Alliance, LLC", id: "RC2500014075" },
      { name: "OHT Texas EB-5, LLC", id: "RC2400011583" },
      { name: "America Investment Regional Center LLC", id: "RC2500013001" },
      { name: "West Bridge Regional Center LLC", id: "RC2400009205" },
      { name: "EB5 United Ranger Regional Center, LLC", id: "RC2500014726" },
      { name: "American Southern Regional Center LLC", id: "RC2200000491" },
      { name: "American Innovation Sunbelt Regional Center, LLC", id: "RC2400009639" },
      { name: "Global Gateway LLC", id: "RC2400011753" },
      { name: "Vanguard Investment and Immigration WSC, LLC", id: "RC2500014390" },
      { name: "Beyond Texas Regional Center LLC", id: "RC2500015367" },
    ],
  },
  "U.": {
    name: "U.S. Virgin Islands (USVI)",
    abbreviation: "U.",
    centers: [
      { name: "United States Virgin Islands Regional Center LLC (former name American Islands Regional Center)", id: "RC2300001866" },
      { name: "USVI Regional Center, LLC", id: "RC2400009229" },
    ],
  },
  "UT": {
    name: "Utah",
    abbreviation: "UT",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Civitas Mountain Regional Center", id: "RC2300003865" },
      { name: "Investment Fund of America, LLC", id: "RC2300002637" },
      { name: "LCP Southwest Regional Center LLC", id: "RC2400006580" },
      { name: "First America Southwest, LLC", id: "RC2300002464" },
      { name: "Monterey Northern California Regional Center, LLC", id: "RC2300002531" },
      { name: "Invest Idaho, LLC", id: "RC2300003970" },
      { name: "Newlifeplan LTD", id: "RC2300002650" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "ALC Rocky Mountain LLC", id: "RC2200000299" },
      { name: "EB5AN Rocky Mountain Regional Center LLC", id: "RC2200000438" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "Extell Utah Regional Center LLC", id: "RC2200000504" },
      { name: "Golden Lamp Regional Center, Inc. (former name Utah High Country Regional Center Inc.)", id: "RC2200001379" },
      { name: "Mountain States Center for Foreign Investment LLC", id: "RC2300003141" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "EB5AN Utah Regional Center LLC", id: "RC2200000739" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Southwest EB5 Regional Center LLC", id: "RC2400009661" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "ADF Mountain Regional Center LLC", id: "RC2400012337" },
      { name: "Texas Lending Alliance, LLC", id: "RC2500014075" },
      { name: "American Greenfield Regional Center LLC", id: "RC2400011778" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
    ],
  },
  "VT": {
    name: "Vermont",
    abbreviation: "VT",
    centers: [
      { name: "CanAm Northeast Regional Center, LLC", id: "RC2300003285" },
      { name: "EB5AN Northeast Regional Center, LLC", id: "RC2300001563" },
      { name: "New England Regional Center for Economic Development Inc.", id: "RC2300005127" },
      { name: "Century Regional Center, LLC (former name Century New York City Regional Center)", id: "RC2300005527" },
      { name: "Manhattan Regional Center, LLC", id: "RC2300002264" },
      { name: "ALC New England LLC", id: "RC2200000451" },
      { name: "Green Mountain Regional Center LLC", id: "RC2300002084" },
      { name: "Smith New England Regional Center LLC", id: "RC2200000340" },
      { name: "Vermont Agency of Commerce and Community Development", id: "ID1031910148" },
      { name: "Peachtree Northeast Regional Center LLC", id: "RC2400008691" },
      { name: "CMB Regional Centers Northeast LLC", id: "RC2400008351" },
      { name: "Global Northeast Regional Center (former name MGV NYC Regional Center LLC)", id: "RC2400009608" },
      { name: "3G Northeast Regional Center, LLC", id: "RC2200001022" },
      { name: "Great American Northeast Regional Center LLC", id: "RC2400009748" },
      { name: "EB5 Group Northeastern States Regional Center LLC", id: "RC2400009666" },
      { name: "U.S. Immigration Fund - NJ LLC", id: "RC2300001673" },
    ],
  },
  "VA": {
    name: "Virginia",
    abbreviation: "VA",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "CanAm Greater Washington Regional Center LLC (former name American Lending Center Virginia, LLC)", id: "RC2300001489" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "Milou Chesapeake Regional Center LLC (former name Oriental Dolphin EB-5 Regional Center)", id: "RC2300002524" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "American Heritage Regional Center, LLC", id: "ID1525452912" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "CanAm New York Metropolitan Regional Center, LLC (former name New York Metropolitan Regional Center)", id: "RC2200000138" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "New York EB5, LLC (former name Smith Atlantic Regional Center LLC) (former name Atlantic Coast Regional Center, LLC)", id: "RC2300005095" },
      { name: "Chesapeake Regional Center, LLC", id: "ID1306051099" },
      { name: "EB5 Capital - DC Regional Center", id: "RC2200000001" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Greystone EB5 Northeast RC LLC", id: "RC2300001506" },
      { name: "Live in America - Washington D.C./Baltimore Regional Center LLC", id: "RC2300001446" },
      { name: "Maryland Center for Foreign Investment, LLC", id: "ID1031910002" },
      { name: "Maryland Global Regional Center, LLC", id: "ID1335851436" },
      { name: "Northeast Regional Center, Inc.", id: "RC2300002104" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "3G Southeast Regional Center, LLC", id: "RC2200001236" },
      { name: "Tran EB5 Regional Center LLC", id: "RC2300005894" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
    ],
  },
  "WA": {
    name: "Washington",
    abbreviation: "WA",
    centers: [
      { name: "CanAm California Regional Center LLC (former name CanAm Los Angeles Conty Regional Center and Los Angeles Film Regional Center)", id: "RC2200000080" },
      { name: "Civitas Pacific Regional Center LLC", id: "RC2300003456" },
      { name: "Live in America – California Regional Center LLC", id: "RC2400006717" },
      { name: "Pacific Coast USA Regional Center LLC", id: "RC2300002990" },
      { name: "Pine State Regional Center Northwest LLC", id: "RC2400009046" },
      { name: "SPI EB5 Pacific RC, LLC", id: "RC2200000409" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "ALC West LLC", id: "RC2200000407" },
      { name: "American Dream Group, LLC", id: "ID1533853501" },
      { name: "GVC Seattle Regional Center LLC", id: "RC2300001426" },
      { name: "American Family Regional Center", id: "RC2300001944" },
      { name: "American NW Regional Center, LLC", id: "ID1315451155" },
      { name: "AmWealth, LP", id: "ID1305651094" },
      { name: "Cascadia Regional Center", id: "RC2200000196" },
      { name: "Coastline Regional Center", id: "ID1515352733" },
      { name: "Columbia International Finance, LLC (former name Columbia International Finance Washington)", id: "RC2300001669" },
      { name: "EB5AN WA OR and Northern Plains Regional Center LLC", id: "RC2300001761" },
      { name: "EB-5 Blaine Tomorrow Regional Center, LLC", id: "RC2300001861" },
      { name: "EB5 Capital - California Regional Center LLC", id: "RC2200000007" },
      { name: "EB5 Land Regional Center", id: "ID1507652629" },
      { name: "Farm for America Regional Center", id: "ID1031910018" },
      { name: "Jabooda Regional Center, LLC", id: "RC2300003417" },
      { name: "NewGen WA Regional Center, LLC", id: "RC2200000256" },
      { name: "North American Asset Management Regional Center, LLC", id: "RC2300006236" },
      { name: "Pacific Northwest EB-5 Regional Center", id: "RC2200000234" },
      { name: "Pacific Northwest Investment RC, LLC", id: "RC2300001590" },
      { name: "Path America KingCo, LLC", id: "ID1031910033" },
      { name: "Path America SnoCo LLC", id: "ID1031910032" },
      { name: "Phoenix Pacific LLC", id: "RC2300004698" },
      { name: "Principal Regional Center, LLC", id: "RC2400009216" },
      { name: "Propet American Dream, LLC", id: "ID1618454352" },
      { name: "Redwood Regional Center, LLC", id: "ID1634954742" },
      { name: "Seattle Area Regional Center, LLC", id: "ID1306351100" },
      { name: "Seattle Family Regional Center", id: "RC2300002152" },
      { name: "Seattle Regional Center", id: "RC2300003134" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "United States Pacific Northwest LLC", id: "RC2400008844" },
      { name: "USASIA Pacific, Inc.", id: "ID1511152669" },
      { name: "West Coast EB5 Regional Center, LLC", id: "RC2200001186" },
      { name: "West Washington United, LLC", id: "ID1031910045" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "Yareton Investment Funds LLC dba Yareton Investment Funds Regional Center", id: "RC2300002321" },
      { name: "Yellow Rock Regional Center of Washington, LLC", id: "ID1502652574" },
      { name: "Zephyrus Regional Center LLC", id: "ID1636255049" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "EB5AN Far West Regional Center LLC", id: "RC2200000215" },
      { name: "Fairhaven Capital Advisors Regional Center", id: "RC2400009514" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "American Life Inc.", id: "RC2400009190" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Manhattan Regional Center – West LLC", id: "RC2400009580" },
      { name: "H and H EB-5 Investment Group LLC", id: "RC2300005724" },
      { name: "EB5 Group Western States Regional Center LLC", id: "RC2400009668" },
      { name: "American Innovation West Coast Regional Center LLC", id: "RC2400009772" },
      { name: "Central Capital Regional Center LLC", id: "RC2500014492" },
    ],
  },
  "WV": {
    name: "West Virginia",
    abbreviation: "WV",
    centers: [
      { name: "ALC Southeast, LLC", id: "RC2200000218" },
      { name: "Civitas Southeast Regional Center LLC", id: "RC2300003501" },
      { name: "Smith Central Atlantic Regional Center, LLC", id: "RC2200000367" },
      { name: "EB-5 Visa Guide Regional Center LLC", id: "RC2400009048" },
      { name: "Florida Regional Center LLC", id: "RC2300001672" },
      { name: "EB5 Capital - DC Regional Center", id: "RC2200000001" },
      { name: "Milou Chesapeake Regional Center LLC (former name Oriental Dolphin EB-5 Regional Center)", id: "RC2300002524" },
      { name: "EB5AN NC and Great Lakes Regional Center, LLC", id: "RC2300001963" },
      { name: "BC East Coast Regional Center LLC", id: "RC2400008530" },
      { name: "Chesapeake Regional Center, LLC", id: "ID1306051099" },
      { name: "CMB Pennsylvania Regional Center, LLC", id: "RC2200000079" },
      { name: "EB5AN D.C. and Carolinas Regional Center LLC", id: "RC2300001548" },
      { name: "Live in America - Washington D.C./Baltimore Regional Center LLC", id: "RC2300001446" },
      { name: "Maryland Global Regional Center, LLC", id: "ID1335851436" },
      { name: "West Virginia Regional Center, LLC", id: "RC2200000548" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "CMB Regional Centers South LLC", id: "RC2200000347" },
      { name: "Peachtree South Regional Center LLC", id: "RC2400008126" },
      { name: "EB5 United South Regional Center LLC", id: "RC2300003307" },
      { name: "Manhattan Regional Center – South LLC", id: "RC2300002585" },
      { name: "Southeast EB-5 Regional Center", id: "RC2400009775" },
      { name: "Great American Southeast Regional Center LLC", id: "RC2400009750" },
      { name: "EB5 Group Southeastern States Regional Center LLC", id: "RC2400009664" },
    ],
  },
  "WI": {
    name: "Wisconsin",
    abbreviation: "WI",
    centers: [
      { name: "Blue Ribbon Regional Center", id: "RC2300001653" },
      { name: "Civitas Midwest Regional Center LLC", id: "RC2300003713" },
      { name: "EB5AN Midwest Regional Center, LLC", id: "RC2300001582" },
      { name: "CanAm Midwest Regional Center, LLC", id: "RC2300003481" },
      { name: "ALC Great Lakes LLC", id: "RC2200000457" },
      { name: "Chicago JD Terra Regional Center LLC", id: "RC2300002053" },
      { name: "Freedom Partners Regional Center LLC", id: "ID1304251084" },
      { name: "Great Lakes Regional Center LLC", id: "RC2300001983" },
      { name: "Great Chicago Regional Center LLC (former name Keystone Great Lakes Regional Center LLC)", id: "ID1527453285" },
      { name: "LaSalle Street Regional Center LLC", id: "RC2200000829" },
      { name: "Metropolitan Milwaukee Association of Commerce (MMAC) Regional Center LLC", id: "RC2300001670" },
      { name: "Smith Central Regional Center LLC (former name Central Western Regional Center LLC) (former name USA Midwest Regional Center LLC)", id: "RC2400008629" },
      { name: "Smith Great Lakes Regional Center LLC", id: "RC2200000265" },
      { name: "Wisconsin EB5 Regional Center LLC", id: "RC2300002078" },
      { name: "Peachtree Midwest Regional Center LLC", id: "RC2400008877" },
      { name: "EB5 United Midwest Regional Center LLC", id: "RC2400009086" },
      { name: "Great American Midwest Regional Center LLC", id: "RC2400009751" },
      { name: "CMB Regional Centers Midwest LLC", id: "RC2200000311" },
      { name: "EB5 Group Midwestern States Regional Center LLC", id: "RC2400009749" },
      { name: "Manhattan Regional Center – Midwest LLC", id: "RC2400009191" },
    ],
  },
  "WY": {
    name: "Wyoming",
    abbreviation: "WY",
    centers: [
      { name: "CanAm Mountain States Regional Center, LLC", id: "RC2300003017" },
      { name: "Rosewood Regional Center LLC", id: "RC2400009182" },
      { name: "EB5 United Rockies Regional Center LLC", id: "RC2200000443" },
      { name: "Mid-America Rural Development Inc.", id: "RC2200001268" },
      { name: "Westus Cre LLC", id: "RC2400009310" },
      { name: "ALC Rocky Mountain LLC", id: "RC2200000299" },
      { name: "EB5AN Rocky Mountain Regional Center LLC", id: "RC2200000438" },
      { name: "EB5 Capital – Mountain Regional Center LLC", id: "RC2200000564" },
      { name: "Smith Rockies Regional Center LLC", id: "RC2200001021" },
      { name: "Smith Western Regional Center (former name Western Pacific Regional Center)", id: "RC2300002453" },
      { name: "CMB Regional Centers West LLC", id: "RC2200000270" },
      { name: "Civitas North Central Regional Center LLC", id: "RC2400009407" },
      { name: "Peachtree West Regional Center LLC", id: "RC2300005953" },
      { name: "Vanguard Investment and Immigration MTN, LLC", id: "RC2500014702" },
    ],
  },
};

export const getStateCounts = (): Record<string, number> => {
  const counts: Record<string, number> = {};
  Object.entries(regionalCentersData).forEach(([abbr, data]) => {
    counts[abbr] = data.centers.length;
  });
  return counts;
};

export const getUniqueCenterCount = (): number => {
  const ids = new Set<string>();
  Object.values(regionalCentersData).forEach((data) => {
    data.centers.forEach((c) => ids.add(c.id));
  });
  return ids.size;
};

export const parseApprovalYear = (id: string): number | null => {
  if (id.startsWith("RC")) {
    const yearDigits = id.substring(2, 4);
    const year = parseInt(yearDigits, 10);
    if (!isNaN(year) && year >= 20 && year <= 30) return 2000 + year;
  }
  return null;
};

export type ApprovalEra = "Post-RIA" | "Pre-RIA" | "Legacy";

export const getApprovalEra = (id: string): ApprovalEra => {
  if (id.startsWith("ID")) return "Legacy";
  const year = parseApprovalYear(id);
  if (!year) return "Legacy";
  if (year >= 2022) return "Post-RIA";
  return "Pre-RIA";
};

export const USCIS_APPROVED_LIST_URL = "https://www.uscis.gov/working-in-the-united-states/permanent-workers/employment-based-immigration-fifth-preference-eb-5/eb-5-immigrant-investor-regional-centers/approved-eb-5-immigrant-investor-regional-centers";
export const USCIS_TERMINATED_LIST_URL = "https://www.uscis.gov/working-in-the-united-states/permanent-workers/employment-based-immigration-fifth-preference-eb-5/eb-5-immigrant-investor-regional-centers/regional-center-terminations";
export const USCIS_APPROVED_COUNT = 580;
export const USCIS_TERMINATED_COUNT = 775;
export const USCIS_DATA_DATE = "September 22, 2025";
